import { useState } from 'react';
import CustomTextAreaInput from '../../InputFields/CustomTextAreaInput';
import Dropdown from '../../../../../components/Dropdown/Dropdown';

const dataTypeOptions = [
  { label: 'DD-MM-YYYY', value: 'dd-mm-yyyy' },
  { label: 'MM-DD-YYYY', value: 'mm-dd-yyyy' },
  { label: 'YYYY-MM-DD', value: 'yyyy-mm-dd' },
];

interface DateDataType {
  onDataChange: (data: { helpText: string; date: string }) => void;
  dateFormat?: string;
  helpText?: string;
}

const DateDataType = ({ onDataChange, dateFormat, helpText }: DateDataType) => {
  const [formData, setFormData] = useState({
    helpText: helpText || '',
    date: dateFormat || '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    onDataChange(updatedFormData);
  };

  const handleFieldTypeChange = (value: string) => {
    const updatedFormData = { ...formData, date: value };
    setFormData(updatedFormData);
    onDataChange(updatedFormData);
  };

  return (
    <>
      <div className="ml-4">
        <CustomTextAreaInput
          label="Help Text"
          name="helpText"
          value={formData.helpText}
          onChange={handleInputChange}
          placeholder="Enter the description. i.e - This section provides key points of contact for communication and support."
          description="This will help in guiding the person filling this field."
          rows={12}
        />
      </div>
      <div className="ml-4">
        <label className="text-xs text-ds-gray-500 font-semibold">
          Date Format <span className="text-ds-red-400">*</span>
        </label>
        <p className="mt-1 text-xs text-ds-gray-300 mb-2">
          Select the format of the Date in which the response will be recorded.
        </p>
        <Dropdown
          options={dataTypeOptions}
          selectedValue={formData.date}
          onChange={handleFieldTypeChange}
          errorMessage="Field type cannot be empty. Please select an option from the dropdown list."
        />
      </div>
    </>
  );
};

export default DateDataType;
